export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/emilyz-9fcf69e5359987c9b1545aae1c2c5faa.jpg";